module.exports = __webpack_public_path__ + "static/media/upload-icon.58b2815a.svg";